import React from "react";
import { Link, useLocation } from "react-router-dom";

const DashboardMenu = () => {
  const location = useLocation();

  const CustomerLoggerdIn = sessionStorage.getItem("Customer-vUniqueCode");
  const ContractorLoggerdIn = sessionStorage.getItem("Contractor-vUniqueCode");

  return (
    <>
      <header>
        <Link to="/">
          <img
            className="dashboard-logo"
            src="assets/images/login-logo.png"
            alt="Header Logo"
            loading="lazy"
          />
        </Link>

        <Link to="/">
          <img
            className="dashboard-logo dash-responsive-logo"
            src="/assets/images/logo.png"
            alt="Header Logo"
            loading="lazy"
          />
        </Link>
      </header>
      <nav className="dashboard-nav-list">
        <Link
          to="/dashboard"
          className={`dashboard-nav-item ${
            location.pathname === "/dashboard" ? "active" : ""
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
          >
            <path
              d="M10.0801 26.7812V18.2812C10.0801 17.5298 10.3786 16.8091 10.9099 16.2778C11.4413 15.7464 12.162 15.4479 12.9134 15.4479H15.7467C16.4982 15.4479 17.2189 15.7464 17.7502 16.2778C18.2816 16.8091 18.5801 17.5298 18.5801 18.2812V26.7812M4.41341 14.0312H1.58008L14.3301 1.28125L27.0801 14.0312H24.2467V23.9479C24.2467 24.6994 23.9482 25.42 23.4169 25.9514C22.8855 26.4827 22.1649 26.7812 21.4134 26.7812H7.24674C6.4953 26.7812 5.77463 26.4827 5.24328 25.9514C4.71192 25.42 4.41341 24.6994 4.41341 23.9479V14.0312Z"
              stroke="#0D3883"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Dashboard </span>
        </Link>
        <Link
          to="/profile"
          className={`dashboard-nav-item ${
            location.pathname === "/profile" ? "active" : ""
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
          >
            <path
              d="M9 27.7812V25.2812C9 23.9552 9.52678 22.6834 10.4645 21.7457C11.4021 20.808 12.6739 20.2812 14 20.2812H19C20.3261 20.2812 21.5979 20.808 22.5355 21.7457C23.4732 22.6834 24 23.9552 24 25.2812V27.7812M11.5 10.2812C11.5 11.6073 12.0268 12.8791 12.9645 13.8168C13.9021 14.7545 15.1739 15.2812 16.5 15.2812C17.8261 15.2812 19.0979 14.7545 20.0355 13.8168C20.9732 12.8791 21.5 11.6073 21.5 10.2812C21.5 8.95517 20.9732 7.6834 20.0355 6.74572C19.0979 5.80803 17.8261 5.28125 16.5 5.28125C15.1739 5.28125 13.9021 5.80803 12.9645 6.74572C12.0268 7.6834 11.5 8.95517 11.5 10.2812Z"
              stroke="#0D3883"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Profile</span>{" "}
        </Link>
        {CustomerLoggerdIn ? (
          <Link
            to="/booking"
            className={`dashboard-nav-item ${
              location.pathname === "/booking" ? "active" : ""
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="27"
              viewBox="0 0 24 27"
              fill="none"
            >
              <path
                d="M17.334 1.53125V6.86458M6.66732 1.53125V6.86458M1.33398 12.1979H22.6673M1.33398 6.86458C1.33398 6.15734 1.61494 5.47906 2.11503 4.97897C2.61513 4.47887 3.29341 4.19792 4.00065 4.19792H20.0007C20.7079 4.19792 21.3862 4.47887 21.8863 4.97897C22.3864 5.47906 22.6673 6.15734 22.6673 6.86458V22.8646C22.6673 23.5718 22.3864 24.2501 21.8863 24.7502C21.3862 25.2503 20.7079 25.5312 20.0007 25.5312H4.00065C3.29341 25.5312 2.61513 25.2503 2.11503 24.7502C1.61494 24.2501 1.33398 23.5718 1.33398 22.8646V6.86458Z"
                stroke="#1F4387"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>Booking</span>{" "}
          </Link>
        ) : (
          ""
        )}
        {ContractorLoggerdIn ? (
          <Link
            to="/jobs"
            className={`dashboard-nav-item ${
              location.pathname === "/jobs" ? "active" : ""
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="27"
              viewBox="0 0 22 27"
              fill="none"
            >
              <path
                d="M6.99935 3.69792H4.33268C3.62544 3.69792 2.94716 3.97887 2.44706 4.47897C1.94697 4.97906 1.66602 5.65734 1.66602 6.36458V22.3646C1.66602 23.0718 1.94697 23.7501 2.44706 24.2502C2.94716 24.7503 3.62544 25.0313 4.33268 25.0313H17.666C18.3733 25.0313 19.0515 24.7503 19.5516 24.2502C20.0517 23.7501 20.3327 23.0718 20.3327 22.3646V6.36458C20.3327 5.65734 20.0517 4.97906 19.5516 4.47897C19.0515 3.97887 18.3733 3.69792 17.666 3.69792H14.9993M6.99935 3.69792C6.99935 2.99067 7.2803 2.3124 7.7804 1.8123C8.28049 1.3122 8.95877 1.03125 9.66602 1.03125H12.3327C13.0399 1.03125 13.7182 1.3122 14.2183 1.8123C14.7184 2.3124 14.9993 2.99067 14.9993 3.69792M6.99935 3.69792C6.99935 4.40516 7.2803 5.08344 7.7804 5.58354C8.28049 6.08363 8.95877 6.36458 9.66602 6.36458H12.3327C13.0399 6.36458 13.7182 6.08363 14.2183 5.58354C14.7184 5.08344 14.9993 4.40516 14.9993 3.69792M6.99935 13.0313H7.01268M12.3327 13.0313H14.9993M6.99935 18.3646H7.01268M12.3327 18.3646H14.9993"
                stroke="#1F4387"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>Jobs </span>
          </Link>
        ) : (
          ""
        )}
        <Link
          to="/notification"
          className={`dashboard-nav-item ${
            location.pathname === "/notification" ? "active" : ""
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="27"
            viewBox="0 0 24 27"
            fill="none"
          >
            <path
              d="M8.00065 20.1296V21.4629C8.00065 22.5238 8.42208 23.5412 9.17222 24.2913C9.92237 25.0415 10.9398 25.4629 12.0007 25.4629C13.0615 25.4629 14.0789 25.0415 14.8291 24.2913C15.5792 23.5412 16.0007 22.5238 16.0007 21.4629V20.1296M9.33398 4.12956C9.33398 3.42231 9.61494 2.74404 10.115 2.24394C10.6151 1.74384 11.2934 1.46289 12.0007 1.46289C12.7079 1.46289 13.3862 1.74384 13.8863 2.24394C14.3864 2.74404 14.6673 3.42231 14.6673 4.12956C16.1985 4.85359 17.5039 5.98066 18.4434 7.38996C19.3829 8.79925 19.9212 10.4377 20.0007 12.1296V16.1296C20.101 16.9585 20.3946 17.7523 20.8577 18.4471C21.3209 19.1418 21.9407 19.7181 22.6673 20.1296H1.33398C2.06057 19.7181 2.6804 19.1418 3.14357 18.4471C3.60674 17.7523 3.90031 16.9585 4.00065 16.1296V12.1296C4.08006 10.4377 4.61839 8.79925 5.55792 7.38996C6.49745 5.98066 7.80277 4.85359 9.33398 4.12956Z"
              stroke="#1F4387"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span> Notification</span>{" "}
        </Link>
        <Link
          to="/reviews"
          className={`dashboard-nav-item ${
            location.pathname === "/reviews" ? "active" : ""
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M7.69141 8.00716H17.6602M7.69141 13.1426H15.168M8.9375 19.5618H5.19922C4.20776 19.5618 3.25692 19.1561 2.55585 18.4338C1.85479 17.7114 1.46094 16.7318 1.46094 15.7103V5.43945C1.46094 4.41796 1.85479 3.4383 2.55585 2.71599C3.25692 1.99368 4.20776 1.58789 5.19922 1.58789H20.1523C21.1438 1.58789 22.0946 1.99368 22.7957 2.71599C23.4968 3.4383 23.8906 4.41796 23.8906 5.43945V15.7103C23.8906 16.7318 23.4968 17.7114 22.7957 18.4338C22.0946 19.1561 21.1438 19.5618 20.1523 19.5618H16.4141L12.6758 23.4134L8.9375 19.5618Z"
              stroke="#1F4387"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Reviews</span>{" "}
        </Link>
        <Link to="/logout" className="dashboard-nav-item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5.33268 4.46549C3.71453 5.83186 2.5553 7.66244 2.01192 9.70941C1.46854 11.7564 1.56725 13.9209 2.29469 15.9099C3.02213 17.8989 4.34316 19.6164 6.07896 20.8298C7.81476 22.0432 9.88148 22.694 11.9994 22.694C14.1172 22.694 16.1839 22.0432 17.9197 20.8298C19.6555 19.6164 20.9766 17.8989 21.704 15.9099C22.4315 13.9209 22.5302 11.7564 21.9868 9.70941C21.4434 7.66244 20.2842 5.83186 18.666 4.46549M11.9993 1.79883V12.4655"
              stroke="#1F4387"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Log out</span>{" "}
        </Link>
      </nav>
    </>
  );
};

export default DashboardMenu;
